import { render, staticRenderFns } from "./TeamGrid.vue?vue&type=template&id=fb36e432"
import script from "./TeamGrid.vue?vue&type=script&lang=js"
export * from "./TeamGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports